import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AuthorizationModule } from '@grotem/grotem.box.angular.auth-lib';
import { UiModule } from '@ui/ui.module';
import {
  API_PATH,
  CATEGORY_RESOURCE_PATH,
  GUARANTEE_RESOURCE_PATH,
  NEWS_RESOURCE_PATH,
  REFUND_RESOURCE_PATH,
  RESOURCE_PATH,
} from '@shared/tokens';
import { SVG_PATH } from '@shared/tokens/svg-path.token';
import { environment } from '../environments/environment';
import { AUTH_CONFIG } from './configs/auth-config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ProxyInterceptor } from './interceptors/proxy.interceptor';
import { AppStoreModule } from './store/store.module';
import { DataModule } from './data/data.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './modules/layout/layout.module';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { LanguageInterceptor } from './interceptors/language.interceptor';
import { LaximoTokensInterceptor } from './interceptors/laximo-tokens.interceptor';
import { providePrimeNG } from 'primeng/config';
import { TissThemeRu } from '../styles/themes/tiss-theme.ru';
import { TissTrTheme } from '../styles/themes/tiss-theme.tr';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgOptimizedImage,
    CoreModule,
    UiModule,
    CommonModule,
    FormsModule,
    AppStoreModule,
    DataModule,
    LayoutModule,
    AuthorizationModule.forRoot(AUTH_CONFIG),
    TranslocoRootModule,
  ],
  providers: [
    { provide: SVG_PATH, useValue: '/assets/images/iconz.svg' },
    {
      provide: API_PATH,
      useValue: `${environment.backendUrl.replace(/\/$/, '')}/bff-b2bweb/v1`,
    },
    {
      provide: RESOURCE_PATH,
      useValue: environment.imageResourceUrl,
    },
    {
      provide: NEWS_RESOURCE_PATH,
      useValue: environment.newsImageResourceUrl,
    },
    {
      provide: GUARANTEE_RESOURCE_PATH,
      useValue: environment.guaranteeFilesResourceUrl,
    },
    {
      provide: REFUND_RESOURCE_PATH,
      useValue: environment.refundFilesResourceUrl,
    },
    {
      provide: CATEGORY_RESOURCE_PATH,
      useValue: environment.categoryResourceUrl,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProxyInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LaximoTokensInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: environment.build === 'tr' ? TissTrTheme : TissThemeRu,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
  ],
})
export class AppModule {}
